import React from 'react';

import type { FormFields } from '../types';

import { Heading } from 'toolkit/chakra/heading';
import { FormFieldAddress } from 'toolkit/components/forms/fields/FormFieldAddress';

import ContractVerificationFormRow from '../ContractVerificationFormRow';
import { useTranslation } from 'next-i18next';
interface Props {
  readOnly?: boolean;
}

const ContractVerificationFieldAddress = ({ readOnly }: Props) => {
  const { t } = useTranslation('common');

  return (
    <>
      <ContractVerificationFormRow>
        <Heading level="2">
          {t('Contract address to verify')}
        </Heading>
      </ContractVerificationFormRow>
      <ContractVerificationFormRow>
        <FormFieldAddress<FormFields>
          name="address"
          required
          placeholder={t("Smart contract / Address (0x...)")}
          readOnly={ readOnly }
        />
      </ContractVerificationFormRow>
    </>
  );
};

export default React.memo(ContractVerificationFieldAddress);
